<app-loader *ngIf="isLogin"></app-loader>
<div class="modal-content2">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'nav.login' | optimizedI18n }}</h5>
    <button class="close" data-dismiss="modal" aria-label="Close"
      (click)="onNo()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="loginFormGroup">
      <div class="form-group">
        <app-input-text type="text" label="{{ 'form.phone_or_email' | optimizedI18n }}"
          placeholder="{{ 'form.phone_or_email_placeholder' | optimizedI18n }}" frmControl="email"
          class_label="white" [formParent]="loginFormGroup" (input)="onEmailInput($event)"
          [maxDigits]="255"></app-input-text>
      </div>

      <!-- Contenedor del input de contraseña -->
      <div class="form-group password-group">
        <app-input-text
          type="{{ typePassword ? 'password' : 'text' }}"
          label="{{ 'form.password' | optimizedI18n }}"
          placeholder="{{ 'form.password' | optimizedI18n }}"
          frmControl="password"
          class_label="white"
          [formParent]="loginFormGroup"
          >
        </app-input-text>
      </div>

      <div class="text-right">
        <a (click)="recoverPass()" class="recoverPass">{{ 'form.forgot_password' | optimizedI18n }}</a>
      </div>

      <button type="submit" class="btn btn-primary btn-block"
        (click)="login()"
        [disabled]="!loginFormGroup.valid || !loginFormGroup.value.password">{{ 'btn.sign_in' | optimizedI18n }}</button>
    </form>

    <div class="text-center mt-3">
      <p class="footerAccount">{{ 'form.no_account' | optimizedI18n }} &nbsp; &nbsp; <a class="btnCrear links"
          (click)="createAccount()">{{ 'nav.register' | optimizedI18n }}</a></p>
    </div>
  </div>
</div>
